/**
 * 剧本类型标签组件
 */

import React from 'react';
import { Tag } from 'antd';
import type { ScriptType } from '../../types';

interface ScriptTagProps {
    type: ScriptType;
}

const SCRIPT_CONFIG = {
    blue: { color: 'blue', label: '🔵 蓝色剧本' },
    green: { color: 'green', label: '🟢 绿色剧本' },
    hybrid: { color: 'purple', label: '⚪ 混合剧本' },
} as const;

export const ScriptTag: React.FC<ScriptTagProps> = ({ type }) => {
    const { color, label } = SCRIPT_CONFIG[type];
    return <Tag color={color}>{label}</Tag>;
};

export default ScriptTag;
